
import React from 'react'
import { compose } from 'widgets-shared/core'
import { Grid, Typography } from '@mui/material'
import { bookmakersNames } from 'smartstream-widgets/constants/bookmakers'
import { withComponentContext } from 'widgets-shared/core'
import { getBookmakerLogoUrlByTheme } from 'smartstream-widgets/utils/logos'
import { Bookmakers } from 'smartstream-widgets/types/sharedModule/core'

import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'
import DynamicImage from 'smartstream-widgets/controls/DynamicImage/DynamicImage'

type Props = {
  bookmakers: Bookmakers,
  isBookmakerLinkEnabled: boolean,
  classes: {
    [K in string]: string
  },
  config: {
    BASE_ASSET_PATH: string,
    oddsComparisonGridBookmakersId: Array<string>
  },
  theme: Theme
}

const styles = (theme: Theme) =>  createStyles({
  bookmakerContainer: {
    flex: '1 1 0',
    padding: `0px 12px 0px 6px`,
    textAlign: 'center',
    width: 110
  },
  logo: {
    display: 'block',
    height: 29,
    margin: `0px 'auto'px`,
    maxWidth: 90,
    objectFit: 'contain'
  },
  offerText: {
    color: theme.palette.text.secondary,
    fontSize: 10,
    lineHeight: 1.2,
    marginTop: 4
  },
  root: {
    flexGrow: 1
  }
})

export function BookmakersAndLogos (props: Props) {
  const { classes, bookmakers = {},isBookmakerLinkEnabled = true, config: { oddsComparisonGridBookmakersId = [] }, theme } = props
  const hasBookmakers = Array.isArray(oddsComparisonGridBookmakersId) && oddsComparisonGridBookmakersId.length > 0

  return (
    <Grid className={classes.root} container wrap='nowrap' justifyContent='space-around' data-testid='bookmakers-and-logos' >
      {hasBookmakers && oddsComparisonGridBookmakersId.map((sourceId) => {
        const { offerText = '', link = '' } = bookmakers[sourceId] || {}

        return (
          <Grid
            alignItems='center'
            className={classes.bookmakerContainer}
            container
            direction='column'
            justifyContent='center'
            key={sourceId}
            component='div'
            data-testid='bookmaker-container'
          >
            <a href={link} target='_blank'>
              <DynamicImage supportedFormats={['webp']}>
                <img
                  src={getBookmakerLogoUrlByTheme(bookmakers[sourceId], theme)}
                  alt={bookmakersNames[sourceId]}
                  className={classes.logo}
                />
              </DynamicImage>
            </a>
            {offerText && <Typography className={classes.offerText} data-testid='offer-text'>
              {
                link && isBookmakerLinkEnabled?
                 <a href={link} className={classes.offerText} target='_blank'>{offerText}</a>
                 :                
                offerText
              }
            </Typography>}
          </Grid>
        )
      })}
    </Grid>
  )
}

export default compose(
  withComponentContext,
  withStyles(styles, { name: 'BookmakersAndLogos', withTheme: true, defaultTheme: getDefaultTheme })
)(BookmakersAndLogos)
